// src/components/TechniciansView.js - Vista actualizada con listado de comisiones
import React from 'react';
import { Icons } from '../utils/icons';
import CommissionsList from './CommissionsList';

const TechniciansView = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white rounded-2xl shadow-lg border p-6">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2 mb-4">
          <Icons.Users />
          Gestión de Técnicos
        </h2>
        <p className="text-gray-600">
          Dashboard para gestionar técnicos, ver sus comisiones y estadísticas
        </p>
      </div>

      {/* Listado de Comisiones */}
      <CommissionsList />
    </div>
  );
};

export default TechniciansView;